import { deleteIntegration } from 'modules/mobileApps/actions';
import { useIntegrationMetadataContext } from 'modules/mobileApps/context/integrationMetadata';
import { ModalType, useModalContext } from 'modules/mobileApps/context/modal';
import { Integration } from 'modules/mobileApps/types';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { getIsModalOpen } from './utils';

export const DeleteIntegrationModal = () => {
  const dispatch = useDispatch();

  const { closeModal, openedModals } = useModalContext();
  const { selectedIntegration } = useIntegrationMetadataContext();

  const handleClose = () => {
    closeModal(ModalType.DeleteIntegrationModal);
  };

  const handleDelete = () => {
    dispatch(deleteIntegration(selectedIntegration ?? ({} as Integration)));
    handleClose();
  };

  return (
    <Modal
      data-test="mobileApps-deleteIntegrationModal"
      isModalOpen={getIsModalOpen(openedModals, ModalType.DeleteIntegrationModal)}
      onClose={handleClose}
      id="delete-integration-modal"
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete integration?</ModalHeader>
      <ModalBody>
        Are you sure you would like to delete <strong>{selectedIntegration?.name}</strong>? This
        cannot be undone.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test="mobileApps-DeleteIntegrationModalDeleteButton"
          onClick={handleDelete}
          size={BUTTON_SIZES.LARGE}
        >
          Delete integration
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
